import gql from 'graphql-tag';

export default gql`
  query productSearch(
    $sort: [ProductSort!]!
    $filter: ProductFilter
    $pagination: Pagination!
    $isBoostKamereoProducts: Boolean
    $isBoostSameProductGroups: Boolean
    $aggregationOptions: AggregationOptions
  ) {
    productSearch(
      sort: $sort
      filter: $filter
      pagination: $pagination
      isBoostKamereoProducts: $isBoostKamereoProducts
      isBoostSameProductGroups: $isBoostSameProductGroups
      aggregationOptions: $aggregationOptions
    ) {
      totalResults
      totalPage
      data {
        id
        supplier {
          id
          name
        }
        imageUrl
        note
        supplierInternalCode
        vat
        uom
        uomLocal
        price
        originalPrice
        savingAmount
        category {
          name
          parent {
            name
          }
        }
        inStock
        name
        isFavorite
        tags
        allowAddToCart
        private
        allowPurchase
        tagImageVn
        tagImageEn
        baseUnit
        baseUom
        netUom
        netUnit
        netUomPrice
        baseUomPrice
        priceV2 {
          price
          originalPrice
          vat
          vatIncluded
        }
      }
      aggregationsData {
        origins
        brandIds
        categoryIdsAndSubCategoryIds
      }
    }
  }
`;
